export const FormsAssignTypesEnum = {
  JobCandidate: {
    key: 1,
    value: 'job-candidate',
  },
  Employee: {
    key: 2,
    value: 'employee',
  },
  User: {
    key: 3,
    value: 'user',
  },
  OnboardingCandidate: {
    key: 4,
    value: 'OnboardingCandidate',
  },
};
